import { Flex, SimpleGrid, Text } from '@chakra-ui/react';

import { PrideRow } from 'app/utils/table/campaigns/prides';

const RUNNING: PrideRow['status'][] = ['VOTING_OPEN', 'VOTING_CLOSED', 'INTERNAL_REVIEW_OPEN'];

function Tile({ label, value, tone }: { label: string; value: number; tone: string }) {
  return (
    <Flex
      bgColor="brand.white"
      borderRadius="10px"
      border="1px solid"
      borderColor="brand.lightGray1"
      p="20px"
      flexDir="column"
      gap="2px"
    >
      <Text textStyle="h3" color={tone}>
        {value}
      </Text>
      <Text textStyle="extraSmallRegular" color="brand.darkGray">
        {label}
      </Text>
    </Flex>
  );
}

/**
 * The totals across every pride, so the exceptions are what a reader looks for rather than every
 * healthy pride in turn.
 */
function CampaignSummary({ prides }: { prides: PrideRow[] }) {
  const running = prides.filter((pride) => RUNNING.includes(pride.status)).length;
  const decided = prides.filter((pride) => pride.outcome).length;
  const needingAttention = prides.filter((pride) => pride.attentionReasons.length > 0).length;

  // The cycle's total, so a reader leads with the figure and breaks it down in the table beneath.
  const nominations = prides.reduce((total, pride) => total + pride.nominationCount, 0);

  return (
    <SimpleGrid columns={{ base: 2, lg: 5 }} gap="16px" data-testid="campaign-summary">
      <Tile label="Prides" value={prides.length} tone="brand.darkPurple" />
      <Tile label="Nominations" value={nominations} tone="brand.darkPurple" />
      <Tile label="Running" value={running} tone="brand.darkPurple" />
      <Tile label="Decided" value={decided} tone="brand.darkPurple" />
      <Tile label="Needing attention" value={needingAttention} tone="text.error" />
    </SimpleGrid>
  );
}

export default CampaignSummary;
